"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importStar(require("styled-components"));
const device_1 = require("@completeanatomy/device");
const i18n_1 = require("@completeanatomy/i18n");
const ui_1 = require("@completeanatomy/ui");
const OfflineIndicator_1 = __importDefault(require("../../atoms/OfflineIndicator"));
function OfflineWarningMessage({ isMobile = false, }) {
    const isOffline = (0, device_1.useIsDeviceOffline)();
    const { t } = (0, i18n_1.useTranslation)();
    const warningMassage = isOffline
        ? t(i18n_1.Strings.diversity.offlineMessage)
        : t(i18n_1.Strings.diversity.switchingChoice);
    return (isOffline && ((0, jsx_runtime_1.jsxs)(WarningContainer, { isMobile: isMobile, "data-e2e": 'OfflineWarningMessage_WarningContainer', children: [(0, jsx_runtime_1.jsx)(StyledOfflineIndicator, { "data-e2e": 'OfflineWarningMessage_StyledOfflineIndicator' }), warningMassage] })));
}
exports.default = OfflineWarningMessage;
const WarningContainer = styled_components_1.default.div `
  display: ${({ isMobile }) => (isMobile ? 'none' : 'flex')};
  justify-content: center;
  width: 100vw;

  color: ${({ theme }) => theme.settings.text};

  font-size: 14px;
  text-align: center;

  ${ui_1.devicePortrait.mobileS((0, styled_components_1.css) `
    position: relative;
    flex-direction: column;
    align-items: center;
    width: auto;
    height: 50px;
    margin: 40px 20px 20px;
    bottom: 10px;
  `)};

  ${({ isMobile }) => ui_1.deviceLandscape.mobileL((0, styled_components_1.css) `
      display: ${isMobile ? 'none' : 'block'};
      position: relative;
      flex-direction: column;
      align-items: center;
      left: 55vw;
      bottom: 180px;
      width: 256px;
    `)};
  ${ui_1.device.laptopS((0, styled_components_1.css) `
    /** z-index required for Windows @see https://elsevier.atlassian.net/browse/E3D4M-21062 */
    z-index: 19;
  `)}

  ${ui_1.deviceLandscape.laptopS((0, styled_components_1.css) `
    display: block;
    position: absolute;
    flex-direction: row;
    align-items: flex-start;
    left: calc(50% - 166px);
    bottom: 10px;
    width: 332px;
    height: 42px;
    line-height: 20px;
  `)};

  ${ui_1.deviceLandscape.laptop((0, styled_components_1.css) `
    left: calc(50% - 200px);
    width: 400px;
  `)};
`;
const StyledOfflineIndicator = (0, styled_components_1.default)(OfflineIndicator_1.default) `
  width: 14px;
  height: 14px;

  ${ui_1.deviceLandscape.mobileL((0, styled_components_1.css) `
    margin: 0 auto;
  `)};

  ${ui_1.deviceLandscape.laptopS((0, styled_components_1.css) `
    display: inline-block;

    margin: 2px;
  `)};
`;
